import { chargerService } from "../../helpers/chargerService";
//import { router } from "../../router";

export const state = {
  loading: false,
  paginations: {},
  limit: 2,
  charger: {
    is_private: "",
    address: "",
    city: "",
    zip_code: "",
    latitude: "",
    longitude: "",
    start_time: "",
    end_time: "",
    image: "",
    qr_code_image_path: "",
  },
  newlocation: {
    is_private: "",
    address: "",
    city: "",
    zip_code: "",
    latitude: "",
    longitude: "",
    id: "",
    start_time: "",
    end_time: "",
    image: "",
    qr_code_image_path: "",
  },
  allCharger: {},
  typesubmit: false,
};

export const actions = {
  getCharger({ dispatch, commit }, { userId }) {
    chargerService.getChargerData(userId).then(
      (charger) => {
        commit("getChargerSuccess", charger);
      },
      (error) => {
        commit("getChargerFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  getChargerLocation({ dispatch, commit }, { locationId }) {
    chargerService.getLocationById(locationId).then(
      (charger) => {
        commit("getChargerLocationSuccess", charger);
      },
      (error) => {
        commit("getChargerLocationFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  resetChargerLocation({ commit }) {
    commit("resetChargerLocationSuccess");
  },

  deleteChargerLocation({ dispatch }, { id }) {
    chargerService.deleteLocation(id).then(
      (user) => {
        dispatch("alert/success", user.data.msg, { root: true });
      },
      (error) => {
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  updateChargerLocation({ dispatch, commit }, data) {
    chargerService.updateLocation(data).then(
      (user) => {
        if (user.status != 200) {
          dispatch("alert/error", user.data.msg, { root: true });
        } else {
          // dispatch('getCharger');
          dispatch("alert/success", user.data.msg, { root: true });
          commit("getChargerLocationSuccess", user);
        }
      },
      (error) => {
        commit("getDoctorExperienceFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  addChargerLocation({ dispatch, commit }, data) {
    chargerService.addChargerLocation(data).then(
      (user) => {
        if (user.status != 200) {
          dispatch("alert/error", user.data.msg, { root: true });
        } else {
          dispatch("alert/success", user.data.msg, { root: true });
          commit("updateChargerSuccess", user.data);
          //router.push({ name: "doctor.list" });
        }
      },
      (error) => {
        commit("updateChargerFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
};

export const mutations = {
  getChargerSuccess(state, user) {
    state.allCharger = user.data.result;
  },
  getChargerLocationSuccess(state, user) {
    state.newlocation = user.data.result;
  },
  resetChargerLocationSuccess(state) {
    state.newlocation = {
      is_private: "0",
      address: "",
      city: "",
      zip_code: "",
      latitude: "",
      longitude: "",
      user_id: "",
      id: "",
      start_time: "",
      end_time: "",
      image: "",
    };
  },
  getDoctorExperienceFailure() {},
  getChargerLocationFailure() {},
  getChargerFailure() {},
  updateChargerSuccess(state, user) {
    state.allcharger = user.data.result;
  },
  updateChargerFailure() {},
};

//to handle state
export const getters = {
  allCharger: (state) => state.allCharger,
  charger: (state) => state.charger,
  newlocation: (state) => state.newlocation,
  paginations: (state) => state.paginations,
  loading: (state) => state.loading,
};
